import { Component, OnInit, inject } from '@angular/core';
import {DataService} from "../../services/data.service";
import {RouterLink} from "@angular/router";
import {NgIf} from "@angular/common";
import {AccessService} from "../../services/access.service";
import {PaginationComponent} from "ngx-bootstrap/pagination";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'app-supplier-product-list',
    imports: [RouterLink, NgIf, PaginationComponent, FormsModule],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3><i class="fa-solid fa-box-open me-2"></i>Lieferantenprodukte <small class="text-muted">({{totalEntries}})</small></h3>
                </div>

                <button type="button" class="btn btn-primary mb-3" [routerLink]="['/supplierproduct', 0]">Lieferantenprodukt anlegen</button>

                <pagination
                    [hidden]="entries?.length == 0"
                    [totalItems]="totalEntries"
                    [itemsPerPage]="paginConfig.itemsPerPage"
                    [(ngModel)]="paginConfig.page"
                    (pageChanged)="listEntries($event)"
                    [maxSize]="20"
                    previousText="Letzte"
                    nextText="Nächste">
                </pagination>

                @if (entries?.length > 0) {
                    <div class="table-responsive">
                        <table class="table table-striped table-hover mb-0 pointer">
                            <thead>
                            <tr>
                                <th (click)="setOrder('supplier')">
                                    Lieferant <i class="fa-solid" *ngIf="predicate == 'supplier'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('name')">
                                    Name <i class="fa-solid" *ngIf="predicate == 'name'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('description')">
                                    Beschreibung <i class="fa-solid" *ngIf="predicate == 'description'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('ean')">
                                    EAN <i class="fa-solid" *ngIf="predicate == 'ean'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('number')">
                                    Nummer <i class="fa-solid" *ngIf="predicate == 'number'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('package_amount')">
                                    Verpackungsanzahl <i class="fa-solid" *ngIf="predicate == 'package_amount'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('package_unit')">
                                    Verpackungseinheit <i class="fa-solid" *ngIf="predicate == 'package_unit'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('tags')">
                                    Tags <i class="fa-solid" *ngIf="predicate == 'tags'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                @for (entry of entries; track entry.id) {
                                    <tr [routerLink]="['/supplierproduct', entry.id]">
                                        <td>{{ entry.supplier }}</td>
                                        <td>{{ entry.name }}</td>
                                        <td>{{ entry.description }}</td>
                                        <td>{{ entry.EAN }}</td>
                                        <td>{{ entry.number }}</td>
                                        <td>{{ entry.package_amount }}</td>
                                        <td>{{ entry.package_unit }}</td>
                                        <td>{{ entry.tags }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        </div>
    `
})
export class SupplierProductListComponent implements OnInit {

    accessService = inject(AccessService);
    private dataService = inject(DataService);

    paginConfig: any = {
        itemsPerPage: 25,
        page: 1
    };
    entries!: any[]|null;
    totalEntries = 0;
    predicate = 'name';
    search: any = {
        text: ''
    };
    reverse = false;

    ngOnInit(): void {
        this.listEntries(this.paginConfig);
    }

    setOrder(order: string): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    checkFilterAndList(): void {
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    listEntries(event: any): void {
        this.paginConfig = event;

        this.entries = null;
        this.dataService.request('SupplierProduct/listAll', {
            page: this.paginConfig.page,
            limit: this.paginConfig.itemsPerPage,
            order: this.predicate,
            reverse: this.reverse,
            filter: this.search.text,
        }).subscribe(response => {
            this.totalEntries = response.total;
            this.entries = response.products;
        });
    }
}
